import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";

// Default form state to ensure consistency
const defaultFormState = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    confirm_password: "",
    language: "English",
    date_of_birth: "",
    gender: "",
};

export const signupStep1 = createAsyncThunk("signupStep1", async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/oauth/signup/step1/`, data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const signupStep2 = createAsyncThunk("signupStep2", async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/oauth/signup/step2/`, data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const signupVerifyAndCreate = createAsyncThunk("signupVerifyAndCreate", async ({ otp }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post(`/oauth/signup/verify/`, { otp });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

export const SignUpSlice = createSlice({
    name: "createAccount",
    initialState: {
        loading: false,
        userDetails: {},
        signupTime: null,
        data: null,
        error: null,
        registerFormState: { ...defaultFormState },
    },
    reducers: {
        setRegisterFormState: (state, action) => {
            // Ensure registerFormState exists before merging
            if (!state.registerFormState) {
                state.registerFormState = {
                    first_name: "",
                    last_name: "",
                    email: "",
                    password: "",
                    confirm_password: "",
                    language: "English",
                    date_of_birth: "",
                    gender: "",
                };
            }
            state.registerFormState = { ...state.registerFormState, ...action.payload };
        },
    },
    extraReducers: (builder) => {
        // signupStep1 action promises
        builder.addCase(signupStep1.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(signupStep1.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(signupStep1.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // signupStep2 action promises
        builder.addCase(signupStep2.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(signupStep2.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(signupStep2.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // signupVerifyAndCreate action promises
        builder.addCase(signupVerifyAndCreate.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(signupVerifyAndCreate.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.error = null;
        });
        builder.addCase(signupVerifyAndCreate.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { setRegisterFormState } = SignUpSlice.actions;

export default SignUpSlice.reducer;
